import { styled } from '@mui/material';

export type SimulationAmountLabelProps = {
  amount: string;
  description: string;
};

const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

const StyledAmount = styled('div')(({ theme }) => ({
  width: theme.spacing(10),
}));

export const SimulationAmountLabel = ({
  amount,
  description,
}: SimulationAmountLabelProps) => {
  return (
    <StyledContainer>
      <StyledAmount>{amount}</StyledAmount>
      {description}
    </StyledContainer>
  );
};
